import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { moduleLabel } from '@/lib/usageTracker';
import { DarkCard, RankedList } from './RankedCard';
import { fmtMinutes, fmtAgo } from './usageApi';

export const TopUsersCard = ({ rows, onSelect }) => {
  const max = Math.max(1, ...rows.map((r) => r.active_minutes));
  const items = rows.map((r) => ({
    key: r.user_id,
    label: r.name,
    sub: `${r.days_active}d active · ${r.top_module ? moduleLabel(r.top_module) : '—'} · ${fmtAgo(r.last_seen)}`,
    icon: (
      <Avatar className="h-5 w-5">
        <AvatarImage src={r.picture} />
        <AvatarFallback className="bg-neutral-700 text-[9px] text-white">{(r.name || '?')[0]}</AvatarFallback>
      </Avatar>
    ),
    value: fmtMinutes(r.active_minutes),
    pct: (r.active_minutes / max) * 100,
    onClick: () => onSelect(r),
  }));
  return (
    <DarkCard title="Top users" hint="By active time · click for timeline" testId="usage-leaderboard">
      <RankedList items={items} testId="usage-leaderboard-list" empty="No user activity in this range" />
    </DarkCard>
  );
};
